var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"position_page_div full-page"},[_c('EvalPosition')],1)}
var staticRenderFns = []

export { render, staticRenderFns }